import { StreamActions } from "@hotwired/turbo";

// Usage: <turbo-stream action="dispatch-event" name="..." detail='{...}'>
StreamActions["dispatch-event"] = function () {
  const name = this.getAttribute("name");
  if (!name) return;

  let detail = {};
  try {
    detail = JSON.parse(this.getAttribute("detail") || "{}");
  } catch (e) {
    detail = {};
  }

  window.dispatchEvent(new CustomEvent(name, { detail }));
};
